import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useState, useEffect, createContext, useContext } from "react";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { DICT } from "@/lib/i18n";

const LangCtx = createContext({ lang: "EN", setLang: () => {}, t: (k) => k });

export const useI18n = () => useContext(LangCtx);

function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("bz_lang") || "EN");
  useEffect(() => {
    localStorage.setItem("bz_lang", lang);
    document.documentElement.lang = lang.toLowerCase();
  }, [lang]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  useEffect(() => {
    const hash = window.location.hash || "";
    if (hash.includes("session_id=")) {
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      if (sid) {
        fetch(`/api/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sid }),
        }).finally(() => {
          window.history.replaceState(null, "", window.location.pathname);
          window.location.reload();
        });
      }
    }
  }, []);

  const t = (key) => DICT[lang]?.[key] ?? DICT.EN[key] ?? key;

  return (
    <LangCtx.Provider value={{ lang, setLang, t }}>
      <div className="App min-h-screen bg-[var(--bz-bg)] text-[var(--bz-ink)]">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid #d1fae5",
              color: "#0f172a",
            },
          }}
        />
      </div>
    </LangCtx.Provider>
  );
}

export default App;
